export default "<router-outlet>\n\n    <app-spinner>\n\n    </app-spinner>\n</router-outlet>\n"